export const LANGUAGES = {
  RU: 'ru',
};

export const TIME_FORMAT = 'HH:mm';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';